// extracted by mini-css-extract-plugin
module.exports = {"modifyEmail":"style_modifyEmail__1WN0j","saveBtn":"style_saveBtn__RsVlZ","tip":"style_tip___OPpP"};